module.exports = __webpack_public_path__ + "assets/media/day22.b911f56e.mp3";